import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-story',
	templateUrl: './story.component.html',
	styleUrls: ['./story.component.css']
})
export class StoryComponent implements OnInit {
	storyForm: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	searchStr: any = '';
	modalTitle: any;
	categoryList: any;
	countryList: any;
	storyList: any;
	optionSelected: any;
	isStoryAvailable: boolean = true;
	btnTitle: any;
	selectedCategoryId: any;
	selectedStoryId: any
	isActivatedAdd: boolean = false;
	isActivatedEdit: boolean = false;
	isActivatedDelete: boolean = false;
	profession: any;
	surveyCategoryList: any;
	category_id: any;
	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService,
		private pagerService: PagerService) { }


	ngOnInit() {
		$(".navbar-brand").text("User Story");
		this.storyForm = new FormGroup({
			storyQuestion: new FormControl("", Validators.compose([
				Validators.required,
			])),
			name: new FormControl("", Validators.compose([
				Validators.required
			])),
		});

		this.pageNo = 1;
		this.limit = 10;
		this.getStoryList(this.pageNo, this.limit, this.searchStr);

	}

	// Get story List
	getStoryList = function (pageNo, limit, SeachStr) {
		this.commonService.process();

		this.authService.getUserStoryDataList(pageNo, limit, SeachStr).subscribe(data => {
			if (data.success) {
				console.log("data", data)
				this.isStoryAvailable = true;

				this.storyList = data.user;
				console.log(this.storyList)
				this.total = data.total;
				console.log(data)
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}

			else {
				this.isStoryAvailable = false;
				this.storyList = [];
			}

			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		this.pagedItems = this.storyList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getStoryList(page, this.limit, this.searchStr);
		}
	}

	// Delete Selected story
	deleteSelectedStory= function (story) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.isActivatedDelete = true;
		this.modalTitle = "Delete Story";
		this.btnTitle = "Yes";
		this.selectedStoryId = story._id;
		this.story = story;
	}

	// manage Story
	manageStory = function (storyForm,) {
		debugger;
		if (this.storyForm.valid && this.isActivatedAdd) {
		
		}
		else if (this.storyForm.valid && this.isActivatedEdit) {

		}
		else if (this.isActivatedDelete) {
			storyForm._id = this.selectedStoryId;
			this.btnTitle = "Deleting...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageStory(storyForm, "delete", this.selectedStoryId).subscribe(data => {

				if (data.success) {

					this.getStoryList(this.pageNo, this.limit);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else {
			this.validationService.validateAllFormFields(this.storyForm);
		}
	}

	// Search Story
	searchStory = function () {
		this.searchStr = jQuery("#search").val();
		this.getStoryList(1, this.limit, this.searchStr);
	}
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/story/story.component.ts